var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IberoHome"},[_c('ShortCampus',{attrs:{"InfoView":_vm.IberoCampus,"TitleRef":_vm.$ml.get('txtIberoCampus')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }